import React from "react";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import { getOrderableQuestionnaires } from "../actions/Questionnaires";
import { getCurrentArticles } from "../../../actions/Users";
import OrderableQuestionnaires from "./OrderableQuestionnaires";
import Icon from "../../../components/Icon";
import Configuration, { translations } from "../../../config";

const mapStateToProps = ( state ) =>
{
	return {
		articles: state.articles,
		fieldOptions: state.fieldOptions,
		orderableQuestionnaires: state.orderableQuestionnaires
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getOrderableQuestionnaires: () =>
		{
			dispatch( getOrderableQuestionnaires() );
		},
		getCurrentArticles: () =>
		{
			dispatch( getCurrentArticles() );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class ScopeOfServicesFields extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = this.props.fieldValues.article
			? this.props.fieldValues.article
			: {
				selected_questionnaires: null,
				questionnaires_count: null,
				users_count: null,
				surveys_count: null,
				contract_duration: null,
				price: null,
				summary_price: null
			};
		
		this.handleStep = this.handleStep.bind( this );
	}
	
	componentDidMount()
	{
		// Hole buchbare Fragebögen und Optionen
		this.props.getOrderableQuestionnaires();
		this.props.getCurrentArticles();
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( translations.de_DE.routes.registration );
		}
		
	} // function componentDidMount()
	
	componentDidUpdate()
	{
		// Wenn bei der Laufzeit nur eine Option zur Auswahl steht dann, diese im State merken
		if ( this.state.questionnaires_count === null && Object.keys( this.props.fieldOptions ).length > 0 )
		{
			let questionnaires_count = 0;
			let users_count = 0;
			let surveys_count = 0;
			let contract_duration = 0;
			
			Object.keys( this.props.fieldOptions.questionnaires_count ).forEach( a_key => questionnaires_count = this.props.fieldOptions.questionnaires_count[ a_key ] );
			Object.keys( this.props.fieldOptions.users_count ).forEach( a_key => users_count = this.props.fieldOptions.users_count[ a_key ] );
			Object.keys( this.props.fieldOptions.surveys_count ).forEach( a_key => surveys_count = this.props.fieldOptions.surveys_count[ a_key ] );
			Object.keys( this.props.fieldOptions.contract_duration ).forEach( a_key => contract_duration = this.props.fieldOptions.contract_duration[ a_key ] );
			
			this.setState( {
				questionnaires_count: questionnaires_count,
				users_count: users_count,
				surveys_count: surveys_count,
				contract_duration: contract_duration
			} );
		}
		
		const articleId = `${this.state.questionnaires_count}-${this.state.users_count}-${this.state.surveys_count}-${this.state.contract_duration}`;
		const price = this.props.articles.hasOwnProperty( articleId )
			? this.props.articles[ articleId ]
			: null;
		
		if ( this.state.price === null && price > 0 )
		{
			this.setState( {
				price: price,
				summary_price: price
			} );
		}
		
		if ( this.state.selected_questionnaires === null && Object.keys( this.props.orderableQuestionnaires ).length > 0 )
		{
			this.setState( {
				selected_questionnaires: Object.keys( this.props.orderableQuestionnaires )
			} );
		}
		
	} // function componentDidMount()
	
	handleStep( a_event, a_next = true )
	{
		this.props.saveValues( this.state, "article" );
		
		if ( a_next )
		{
			this.props.nextStep();
		}
		else
		{
			this.props.previousStep();
		}
		
	} // function handleStep(...)
	
	render()
	{
		const { orderableQuestionnaires } = { ...this.props };
		
		return ( this.state.summary_price > 0 &&
			<div className={"col s12"}>
				<h3>Warenkorb</h3>
				<div className={"margin-top margin-bottom"}>Ihr monatlicher Leistungsumfang besteht aus einer monatlichen Grundgebühr von
					<div className={"price"}>
						<span className={"value"}>
							{this.state.summary_price > 0
								? ( parseFloat( this.state.summary_price ) ).toLocaleString( Configuration.location, Configuration.priceString )
								: "NAN"}
							</span>
						<span className={"additional"}>Euro</span>
					</div>
					und einer Nutzungsgebühr je durchgeführte Richtlinienrecherche.
				</div>
				
				{orderableQuestionnaires.length > 0 && <OrderableQuestionnaires questionnaires={orderableQuestionnaires} basicPriceInfo/>}
				
				<div className={"cleared spacer"}/>
				<button className={"secondary-color"} type={"button"} onClick={a_event => this.handleStep( a_event, false )}>
					<Icon key={`form-new-user-cancel-icon`} iconName={"leave"}/>
					<span key={`form-new-user-cancel-text`}>Zurück zu persönlichen Daten</span>
				</button>
				<button type={"button"} onClick={a_event => this.handleStep( a_event )}>
					<Icon key={`form-new-user-icon`} iconName={"next"}/>
					<span key={`form-new-user-text`}>nächster Schritt</span>
				</button>
			</div>
		);
		
	} // function render()
	
} // class

ScopeOfServicesFields = connect(
	mapStateToProps,
	mapDispatchToProps
)( ScopeOfServicesFields );

export default ScopeOfServicesFields;
